import React from "react";

export default function ShieldIcon() {
  return (
    <svg
      width="96"
      height="120"
      viewBox="0 0 96 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M95.4989 31.0641C95.4989 31.0641 88.5391 86.8351 77.1005 99.385C63.418 114.438 53.3842 112.236 47.9112 120C42.3653 112.227 32.4044 114.438 18.7219 99.3759C7.2834 86.826 0.341797 31.055 0.341797 31.055C30.4432 16.4409 47.9568 0 47.9568 0C48.4129 0.520627 65.8353 16.6509 95.4989 31.0641Z"
        fill="#144579"
      />
      <path
        d="M47.8741 0.0182715V120C42.3281 112.227 32.3673 114.438 18.6848 99.3759C7.24626 86.826 0.304688 31.055 0.304688 31.055C30.4061 16.4409 47.9197 0 47.9197 0L47.8741 0.0182715Z"
        fill="#3B7CBE"
      />
      <path
        d="M88.1476 35.5578C88.1476 35.5578 82.2732 82.67 72.6408 93.2744C61.0289 106.007 52.5732 104.134 47.9302 110.693C43.2508 104.134 34.8316 106.007 23.2197 93.2744C13.569 82.67 7.71289 35.5578 7.71289 35.5578C33.1623 23.1815 47.9394 9.31641 47.9394 9.31641C47.9394 9.31641 62.6526 23.1815 88.1476 35.5578Z"
        fill="#3B7CBE"
      />
      <path
        d="M7.64453 35.5585C7.64453 35.5585 13.5189 82.6616 23.1513 93.2751C34.745 105.998 43.1551 104.144 47.8437 110.684V9.29883C47.4241 9.80119 32.7017 23.374 7.64453 35.5585Z"
        fill="#144579"
      />
      <path
        d="M61.0667 73.2136C68.3515 65.9192 68.3515 54.0925 61.0667 46.7981C53.782 39.5036 41.9711 39.5036 34.6863 46.7981C27.4016 54.0925 27.4016 65.9192 34.6863 73.2137C41.9711 80.5081 53.782 80.5081 61.0667 73.2136Z"
        fill="#ABC5E3"
      />
      <path
        d="M45.7493 72.1466L37.4395 63.4878L40.5226 60.5193L45.1017 65.2963L54.9713 50.125L58.5561 52.4633L45.7493 72.1466Z"
        fill="#F2F6FB"
      />
    </svg>
  );
}
